import { networkService } from "../config/axios";

const errorMessage = (error, fallback) => error?.response?.data?.error || fallback;

const call = async (url, method = "POST", payload = {}) => {
  try {
    const response = await networkService(url, method, method === "GET" ? null : payload);
    return { ok: true, data: response?.data };
  } catch (error) {
    return { ok: false, data: error?.response?.data, error: errorMessage(error, "Something went wrong. Please try again.") };
  }
};

export const fetchImpersonationState = () => call("/impersonation/state.json", "GET");
export const createImpersonationRequest = (targetUserId, reason, returnTo) =>
  call("/admin/impersonation_sessions.json", "POST", { target_user_id: targetUserId, reason, return_to: returnTo });
export const cancelImpersonationRequest = (id) => call(`/admin/impersonation_sessions/${id}/cancel.json`);
export const enterImpersonation = (id) => call(`/admin/impersonation_sessions/${id}/enter.json`);
export const stopImpersonation = () => call("/admin/stop_impersonating.json");
export const acceptImpersonationRequest = (id) => call(`/impersonation/requests/${id}/accept.json`);
export const declineImpersonationRequest = (id) => call(`/impersonation/requests/${id}/decline.json`);
export const endImpersonationAccess = (id) => call(`/impersonation/sessions/${id}/end.json`);
